import React from 'react';

import Modelo from '../index';

const ModeloMensagem: React.FC = () => {
  return <Modelo modeloMensagem />;
};

export default ModeloMensagem;
